import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Lock, LogIn, ArrowLeft, AlertCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/admin/login`, { email, password });
      localStorage.setItem("grizzly_admin_token", res.data.token);
      localStorage.setItem("grizzly_admin_email", res.data.email);
      navigate("/admin");
    } catch (err) {
      setError(
        err.response?.data?.detail || "Échec de connexion. Vérifiez vos identifiants.",
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      data-testid="admin-login-page"
      className="min-h-screen bg-obsidian text-ivory flex items-center justify-center px-6 grain"
    >
      <div className="w-full max-w-md">
        <button
          data-testid="back-to-site"
          onClick={() => navigate("/")}
          className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-ivory/55 hover:text-copper transition-colors mb-10"
        >
          <ArrowLeft size={14} /> Retour au site
        </button>

        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-14 h-14 border border-copper/40 mb-6">
            <Lock size={20} className="text-copper" strokeWidth={1.5} />
          </div>
          <h1 className="font-serif text-5xl font-light text-ivory tracking-tight mb-2">
            Grizzly
          </h1>
          <p className="overline">Administration</p>
        </div>

        <form
          onSubmit={onSubmit}
          data-testid="admin-login-form"
          className="bg-surface border border-edge p-8 space-y-7"
        >
          <div>
            <label className="overline block mb-3">Email</label>
            <input
              data-testid="admin-login-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-elegant"
              placeholder="info@restaurant-grizzly.ch"
              autoFocus
            />
          </div>
          <div>
            <label className="overline block mb-3">Mot de passe</label>
            <input
              data-testid="admin-login-password"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input-elegant"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div
              data-testid="admin-login-error"
              className="flex items-center gap-3 text-wine border border-wine/40 bg-wine/5 px-4 py-3"
            >
              <AlertCircle size={16} />
              <span className="text-sm">{error}</span>
            </div>
          )}

          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="btn-primary w-full justify-center disabled:opacity-60"
          >
            {loading ? "Connexion..." : "Se connecter"} <LogIn size={14} />
          </button>
        </form>

        <p className="mt-8 text-center text-xs text-ivory/35 tracking-wider">
          Restaurant Grizzly · Le Grand-Saconnex
        </p>
      </div>
    </div>
  );
};

export default AdminLogin;
